module.exports = "//public.getcloudapp.com/packs/media/images/markers/m_8-dea1b8577ae3acff00c3c2b3aea507f9.svg";